


















































import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
class Pagination extends Vue {
  @Prop({type: Number, default: 2, required: false})
  offset!: number

  @Prop({type: Object, default: null, required: false})
  scrollTo?: object

  @Prop({type: Object, default: () => {return {}}, required: false})
  data!: any

  @Prop({type: String, default: '', required: false})
  paginationClass: string

  get lastPage () {
    return this.data.lastPage || this.data.last_page
  }

  get currentPage () {
    return this.data.currentPage || this.data.current_page
  }

  get array () {
    if (this.lastPage <= 0) {
      return []
    }

    let from = this.currentPage - this.offset

    if (from < 1) {
      from = 1
    }

    let to = from + (this.offset * 2)

    if (to > this.lastPage) {
      to = this.lastPage
    }

    const arr: number[] = []

    while (from <= to) {
      arr.push(from++)
    }

    return arr
  }

  changePage (page) {
    this.$scrollTo(this.scrollTo || this.$root.$el)
    this.$emit('change-page', page)
  }
}

export default Pagination
